module.exports = __webpack_public_path__ + "img/horizontal_6_5_pp2_9006.e2c54e77.png";